import { ServiceStepText } from "./types";

export const SERVICE_INFO_STEP = 0;
export const SERVICE_DOCUMENTS_STEP = 1;

/** Naslov i objašnjenje ispod scene, po koraku. */
export const SERVICE_INTRO_TEXTS: Record<number, ServiceStepText> = {
  [SERVICE_INFO_STEP]: {
    title: "Vozilo ide na servis",
    description: "Zabilježite kod koga je vozilo, što se radi i do kada. Štete se vežu na isti nalog.",
  },
  [SERVICE_DOCUMENTS_STEP]: {
    title: "Priložite dokumentaciju",
    description: "Radni nalog, račun servisa ili garancija. Poslije se zna što je rađeno i koliko je koštalo.",
  },
};

/** Tijek servisnog naloga, redom kao statusi naloga. */
export const SERVICE_STATUS_STEPS = [
  { id: "received", name: "Zaprimljeno" },
  { id: "in_progress", name: "U radu" },
  { id: "done", name: "Gotovo" },
  { id: "picked_up", name: "Preuzeto" },
];

/** Primjeri dok korisnik ništa nije upisao. */
export const SERVICE_INTRO_SAMPLE = {
  name: "Mali servis i zamjena kočnica",
  description: "Zamjena ulja i filtera, prednje pločice i diskovi.",
  image: "/media/images/vehicles/vehicle-3.png",
  kmTraveled: 84500,
  documents: ["Radni nalog.pdf", "Račun servisa.pdf", "Jamstveni list.pdf"],
};
